export default "__VITE_ASSET__CuXXtTdI__"